import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';
import { SchoolClass } from '@/models/school-class/school-class';
import { AdditionalPlan } from '@/models/additional-plan/additional-plan';
import { store } from '@/store';

export class Account implements Serializable<Account> {
  userID: number;
  companyID: number;
  companyName: number;
  email: string;
  name: string;
  firstName: string; // 名
  lastName: string; // 姓
  nativeLanguageID: number;
  role: GEnum.Role; // 権限
  schoolClasses: SchoolClass[];
  teacherID: number;
  schoolYear: number;
  firstSchoolYear: number;
  isCompletedInitialSetting: boolean = false;
  additionalPlans: AdditionalPlan[]; // 追加サービスプラン一覧
  dispCtrlType: number; // 画面制御タイプ（内田洋行用）
  isLgateSchool: boolean = false;

  deserialize(input: any): Account {
    this.userID = input.userID;
    this.name = input.name;
    this.firstName = input.firstName;
    this.lastName = input.lastName;
    this.email = input.email;
    this.nativeLanguageID = input.nativeLanguageID;
    this.companyID = input.companyID;
    this.companyName = input.companyName;
    this.role = input.role;
    this.schoolClasses = input.schoolClasses;
    this.teacherID = input.teacherID;
    this.schoolYear = input.schoolYear;
    this.firstSchoolYear = input.firstSchoolYear;
    this.isCompletedInitialSetting = input.isCompletedInitialSetting;
    this.additionalPlans = input.additionalPlans || [];
    this.dispCtrlType = input.dispCtrlType || 1;
    this.isLgateSchool = input.isLgateSchool;

    return this;
  }

  // 進級対象だった場合
  get isPromotion(): boolean {
    return this.schoolYear > this.firstSchoolYear;
  }

  get isRoleAdmin(): boolean {
    return this.role === GEnum.Role.Admin;
  }

  get isRoleNormal(): boolean {
    return this.role === GEnum.Role.Normal;
  }

  get isRoleIgsAdmin(): boolean {
    return this.role === GEnum.Role.IgsAdmin;
  }

  get additionalPlanTypes(): number[] {
    return this.additionalPlans.map((ap: AdditionalPlan) => ap.additionalType);
  }

  get fullName(): string {
    if (store.getters.isNameOrder) {
      // 日本語と同じ 姓 + 名
      return `${this.lastName} ${this.firstName}`;
    } else {
      // 日本語とは異なる 名 + 姓
      return `${this.firstName} ${this.lastName}`;
    }
  }

  isResponsibleSchoolClass(schoolClassID: number): boolean {
    return this.schoolClasses.some((schoolClass: SchoolClass) => schoolClass.schoolClassID === schoolClassID);
  }
}
